"use strict";

exports.__esModule = true;
exports.useTooltip = exports.useTooltipHandlers = void 0;

var _react = require("react");

var _context = require("./context");

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
const useTooltipHandlers = container => {
  const _useState = (0, _react.useState)({
    isVisible: false,
    content: null,
    position: {}
  }),
        state = _useState[0],
        setState = _useState[1];

  const showTooltipAt = (0, _react.useCallback)((content, [x, y], anchor) => {
    setState({
      isVisible: true,
      position: [x, y],
      anchor,
      content
    });
  }, []);
  const showTooltipFromEvent = (0, _react.useCallback)((content, event, anchor) => {
    const bounds = container.current.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    setState({
      isVisible: true,
      position: [x, y],
      anchor,
      content
    });
  }, [container]);
  const hideTooltip = (0, _react.useCallback)(() => {
    setState({
      isVisible: false,
      content: null
    });
  });
  return {
    showTooltipAt,
    showTooltipFromEvent,
    hideTooltip,
    isTooltipVisible: state.isVisible,
    tooltipPosition: state.position,
    tooltipAnchor: state.anchor,
    tooltipContent: state.content
  };
};

exports.useTooltipHandlers = useTooltipHandlers;

const useTooltip = () => (0, _react.useContext)(_context.tooltipContext);

exports.useTooltip = useTooltip;